import React from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import RowTable from "./row_table/row_table";
import './table_component.scss';
import {TFunction} from "i18next";

interface InputTableData{
    title?: string;
    docs: Array<objectArray>;
}

class TableComponent extends TemplateComponent<InputTableData, TemplateComponentProps<InputTableData>> {

    constructor(props: any) {
        super(props);
        this.requireInternationalization = true;
    }

    internationalComponentRender(data: InputTableData, t: TFunction): React.ReactElement<any> {
        return (
                <>
                {(data.title) ? <h3 className={"component-title"}>{data.title}</h3> : null}
                <table className="table-component">
                    <tbody>
                            <tr>
                                <th>{t("C15 name")}</th>
                                <th className={"d-none d-md-table-cell"}>{t("C15 size")}</th>
                                <th />
                            </tr>
                        {data.docs.map((value:objectArray, i) => {
                            return(
                                <RowTable {...value} key={i} />
                            );
                          })
                        }
                    </tbody>
                </table>
                </>
        );
    }
}

export default TableComponent;
export type objectArray = {title:string, size:string, url:string}
